// import { RiHomeHeartFill } from "react-icons/ri";
import { FaUsers } from 'react-icons/fa';
import { FaCubesStacked } from 'react-icons/fa6';
import { IoBarChartSharp } from 'react-icons/io5';

export const version = '22.12.2'; //версия приложения

export const BACKEND_URL_PREFIX = process.env.REACT_APP_URL;
export const BACKEND_DOMAIN = process.env.REACT_APP_BACKEND_DOMAIN;

export const itemsOnPage = 20;

export const itemsCount = [10, 15, 20, 25, 30];

export const mainMenu = [
  // {
  //     name: 'Главная',
  //     link: '/',
  //     icon: <RiHomeHeartFill/>,
  //     innerLinks: [
  //         {
  //             name: 'text',
  //             link: 'text'
  //         }`
  //     ]
  // },
  {
    name: 'Позиции',
    link: '/pos',
    icon: <IoBarChartSharp />,
    innerLinks: [
      {
        name: 'text',
        link: 'text',
      },
    ],
  },
  {
    name: 'Сайты',
    link: '/sites',
    icon: <FaCubesStacked />,
    innerLinks: [
      {
        name: 'text',
        link: 'text',
      },
    ],
  },
  {
    name: 'Пользователи',
    link: '/users',
    icon: <FaUsers />,
    innerLinks: [
      {
        name: 'text',
        link: 'text',
      },
    ],
  },
  // {
  //     name: 'Категории',
  //     link: '/category',
  //     icon: <BiCategoryAlt/>,
  //     innerLinks: [
  //         {
  //             name: 'text',
  //             link: 'text'
  //         }
  //     ]
  // }
];
